import { render, staticRenderFns } from "./logs_group.vue?vue&type=template&id=6315af2d&"
import script from "./logs_group.vue?vue&type=script&lang=js&"
export * from "./logs_group.vue?vue&type=script&lang=js&"
import style0 from "./logs_group.vue?vue&type=style&index=0&id=6315af2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports